import { PropsWithChildren } from 'react'
import getUserLocale from 'get-user-locale'

import { AppProvider } from '@shopify/polaris'
import translationsCs from '@shopify/polaris/locales/cs.json'
import translationsEn from '@shopify/polaris/locales/en.json'

export function I18nProvider({ children }: PropsWithChildren<{}>) {
  const locale = getUserLocale()
  const polarisTranslations = locale === 'cs' || locale === 'cs-CZ' ? translationsCs : translationsEn
  
  return <AppProvider i18n={polarisTranslations}>{children}</AppProvider>
}
